import { createFileRoute } from "@tanstack/react-router";
import { CancellationPage } from "../../../features/cancellation";

export const Route = createFileRoute("/$lang/_layout/cancellation-policy")({
  component: CancellationPage,
});
